import React from "react";

import { formatDate, isDelayed } from "Helpers/date";
import { getNameFromListByType, getNameFromObject } from "Helpers/name";

import StatusIndicator from "Components/project/Common/StatusIndicator/StatusIndicator";

export const Columns = {
    status: {
        label: "Status",
        Component: task => {
            return (
                <StatusIndicator status={task.status} />
            )
        }
    },
    assignee: {
        label: "Assignee",
        Component: task => {
            return (
                <div class="taskAssignee">
                    <span>{getNameFromListByType(task.task_members, "assignedTo")}</span>
                </div>
            )
        }
    },
    approver: {
        label: "Approver",
        Component: task => {
            return (
                <div class="taskApprover">
                    <span>{getNameFromListByType(task.task_members, "approver")}</span>
                </div>
            )
        }
    },
    reviewer: {
        label: "Reviewer",
        Component: task => {
            return (
                <div class="taskApprover">
                    <span>{getNameFromListByType(task.task_members, "reviewer")}</span>
                </div>
            )
        }
    },
    dueDate: {
        label: "Due Date",
        Component: task => {
            return (
                <div class={`taskDueDate ${isDelayed(task.dueDate) ? "delayedTask" : ""}`}>
                    <span>{formatDate(task.dueDate)}</span>
                </div>
            )
        }
    },
    uploadedBy: {
        label: "Uploaded By",
        Component: file => {
            return (
                <div class="fileUploadedBy">
                    <span>{getNameFromObject(file.user)}</span>
                </div>
            )
        }
    },
    uploadedDate: {
        label: "Uploaded Date",
        Component: file => {
            return <span>{formatDate(file.dateAdded)}</span>
        }
    },
    from: {
        label: "From",
        Component: inbox => {
            return <span>{inbox.from}</span>
        }
    },
    dateTime: {
        label: "Date/Time Created",
        Component: inbox => {
            return <span>{inbox.dateTime}</span>
        }
    },
    subject: {
        label: "Subject",
        Component: inbox => {
            return <span>{inbox.subject}</span>
        }
    },
    inboxStatus: {
        label: "Status",
        Component: inbox => {
            return <div class={`inboxStatus ${inbox.inboxStatus.toLowerCase()}`}><span>{inbox.inboxStatus}</span></div>
        }
    }
};